export default p => "PREFIX skos: <http://www.w3.org/2004/02/skos/core#> CONSTRUCT WHERE { " +
	p.node +
	" skos:inScheme ?glossary } ";
